/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExperienceLevelResource = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type ExperienceLevelResource = typeof ExperienceLevelResource[keyof typeof ExperienceLevelResource];


export function instanceOfExperienceLevelResource(value: any): boolean {
    for (const key in ExperienceLevelResource) {
        if (Object.prototype.hasOwnProperty.call(ExperienceLevelResource, key)) {
            // @ts-ignore
            if (ExperienceLevelResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExperienceLevelResourceFromJSON(json: any): ExperienceLevelResource {
    return ExperienceLevelResourceFromJSONTyped(json, false);
}

export function ExperienceLevelResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceLevelResource {
    return json as ExperienceLevelResource;
}

export function ExperienceLevelResourceToJSON(value?: ExperienceLevelResource | null): any {
    return value as any;
}

